import 'titon-toolkit';

Toolkit.namespace = 'netc-';



// WEBPACK FOOTER //
// ./js/core/titon.js